<dashboard-dialog-frame class="acc-application-dialog" [header]="headerName()" [actions]="actions()" [dialogRef]="dialogRef">

	@if(accApplicationDetails(); as accApplication){
	<kendo-tabstrip class="h-100 px-2 pt-2">

		<kendo-tabstrip-tab title="Overview" [selected]="true">
			<ng-template kendoTabContent>
				<acc-application-overview-content-dialog-part></acc-application-overview-content-dialog-part>
			</ng-template>
		</kendo-tabstrip-tab>

		<kendo-tabstrip-tab title="Status Log">
			<ng-template kendoTabContent>
				<acc-application-status-log-dialog-part></acc-application-status-log-dialog-part>
			</ng-template>
		</kendo-tabstrip-tab>

		<kendo-tabstrip-tab title="Interview">
			<ng-template kendoTabContent>
				<acc-application-dialog-interview-part></acc-application-dialog-interview-part>
			</ng-template>
		</kendo-tabstrip-tab>

		<kendo-tabstrip-tab title="Schedule">
			<ng-template kendoTabContent>
				<acc-application-dialog-schedule-part></acc-application-dialog-schedule-part>
			</ng-template>
		</kendo-tabstrip-tab>

		<kendo-tabstrip-tab title="Contact">
			<ng-template kendoTabContent>
				<acc-application-contact-dialog-part [dialogBodyHeight]="dialogBodyHeight()"></acc-application-contact-dialog-part>
			</ng-template>
		</kendo-tabstrip-tab>

		<kendo-tabstrip-tab title="Aligned Commitments">
			<ng-template kendoTabContent>
				<application-dialog-aligned-commitments-part [dialogBodyHeight]="dialogBodyHeight()"></application-dialog-aligned-commitments-part>
			</ng-template>
		</kendo-tabstrip-tab>

		<kendo-tabstrip-tab title="Aligned Accelerators">
			<ng-template kendoTabContent>
				<application-dialog-aligned-accelerators-part [dialogBodyHeight]="dialogBodyHeight()"></application-dialog-aligned-accelerators-part>

			</ng-template>
		</kendo-tabstrip-tab>

		@if (canManageApplication()) {
		<kendo-tabstrip-tab title="Management">
			<ng-template kendoTabContent>
				<acc-application-management-dialog-part></acc-application-management-dialog-part>
			</ng-template>
		</kendo-tabstrip-tab>
		}

	</kendo-tabstrip>
	}@else if(isNotProdEnvironment) {
	<common-message alertType='info'>
		The record for this application does not exist in the development database yet. Please go to
		programs.eforall.org to see the latest data.
	</common-message>
	}

</dashboard-dialog-frame>